/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Recentsales_Customer1Inputs */

const he_dashboard_recentsales_customer1 = /** @type {(inputs: Dashboard_Recentsales_Customer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לקוח`)
};

const en_dashboard_recentsales_customer1 = /** @type {(inputs: Dashboard_Recentsales_Customer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer`)
};

/**
* | output |
* | --- |
* | "Customer" |
*
* @param {Dashboard_Recentsales_Customer1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const dashboard_recentsales_customer1 = /** @type {((inputs?: Dashboard_Recentsales_Customer1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Recentsales_Customer1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_dashboard_recentsales_customer1(inputs)
	return en_dashboard_recentsales_customer1(inputs)
});
export { dashboard_recentsales_customer1 as "dashboard_recentSales_customer" }